import { render, staticRenderFns } from "./select-rut.vue?vue&type=template&id=5ad31831&"
import script from "./select-rut.vue?vue&type=script&lang=js&"
export * from "./select-rut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports